import * as React from 'react';

import { ViewMedium, Viewport, ViewSmall } from 'bernie-view';

import { PriceBreakDownDetailsViewModel, PriceBreakDownViewModel } from 'models';

import { PriceBreakDownContent } from './price-breakdown-content';
import { PriceBreakDownDetails } from './price-breakdown-details';
import { PriceBreakDownDialog } from './price-breakdown-dialog';
import { PriceBreakDownMenu } from './price-breakdown-menu';

export interface ChildActionsOptions {
  trackingRfrr?: string;
  className?: string;
}

export interface PriceBreakDownProps {
  priceBreakDownModel?: PriceBreakDownViewModel[];
  lodgingPriceBreakDown?: PriceBreakDownDetailsViewModel;
  id?: string;
  roomName?: string;
  layerId: string | number;
  childActions?: (options: ChildActionsOptions) => React.ReactNode;
}

export const PriceBreakDown: React.FunctionComponent<PriceBreakDownProps> = props => {
  const { priceBreakDownModel, lodgingPriceBreakDown, id, roomName, layerId, childActions } = props;

  if (!priceBreakDownModel && !lodgingPriceBreakDown) {
    return null;
  }

  let header;
  if (priceBreakDownModel && priceBreakDownModel.length > 0) {
    header = priceBreakDownModel[0].breakdownHeader;
  } else if (lodgingPriceBreakDown) {
    header = lodgingPriceBreakDown.header;
  }

  const commonPriceBreakdownProps = {
    id,
    header
  };

  const commonPriceBreakDownContentProps = {
    priceBreakDownModel,
    lodgingPriceBreakDown,
    roomName
  };

  const childActionDialog = typeof childActions === 'function' ? childActions({ trackingRfrr: 'PriceDetailDialog' }) : null;
  const childActionMenu = typeof childActions === 'function' ? childActions({ trackingRfrr: 'PriceDetailMenu' }) : null;
  const childActionMenuPDP =
    typeof childActions === 'function'
      ? childActions({ trackingRfrr: 'PriceDetailMenu', className: 'all-x-padding-four all-t-padding-four' })
      : null;

  return (
    <div className="price-details">
      {priceBreakDownModel && priceBreakDownModel.length > 0 && (
        <Viewport>
          <ViewSmall>
            <PriceBreakDownDialog
              {...commonPriceBreakdownProps}
              layerId={layerId}
              childContent={<PriceBreakDownContent {...commonPriceBreakDownContentProps} view="small" childActions={childActionDialog} />}
            />
          </ViewSmall>
          <ViewMedium>
            <PriceBreakDownMenu
              {...commonPriceBreakdownProps}
              childContent={<PriceBreakDownContent {...commonPriceBreakDownContentProps} childActions={childActionMenuPDP} />}
            />
          </ViewMedium>
        </Viewport>
      )}
      {lodgingPriceBreakDown && (
        <Viewport>
          <ViewSmall>
            <PriceBreakDownDialog
              {...commonPriceBreakdownProps}
              layerId={layerId}
              childContent={<PriceBreakDownDetails {...commonPriceBreakDownContentProps} childActions={childActionDialog} />}
            />
          </ViewSmall>
          <ViewMedium>
            <PriceBreakDownMenu
              {...commonPriceBreakdownProps}
              childContent={
                <PriceBreakDownDetails {...commonPriceBreakDownContentProps} childActions={childActionMenu} shouldDisplayHeader={true} />}
            />
          </ViewMedium>
        </Viewport>
      )}
    </div>
  );
};
